import { IconMonitor, IconMoon, IconSun } from '../ui/icons.js';
import { useTheme, type ThemeChoice } from '../ui/theme.js';
import styles from './ThemeSwitch.module.css';

const CHOICES: readonly [ThemeChoice, typeof IconSun, string][] = [
  ['light', IconSun, 'Light'],
  ['dark', IconMoon, 'Dark'],
  ['system', IconMonitor, 'System'],
];

/**
 * Light / dark / follow the computer, as a three-way segmented control — the
 * Avatar Assistant's `.theme-switch`. Three buttons rather than a toggle,
 * because "system" is a real third answer and not a state between the other two.
 */
export function ThemeSwitch({ className }: { className?: string | undefined }): JSX.Element {
  const [theme, setTheme] = useTheme();
  return (
    <div className={`${styles.switch} ${className ?? ''}`} role="group" aria-label="Theme">
      {CHOICES.map(([id, Icon, label]) => (
        <button
          key={id}
          type="button"
          className={theme === id ? styles.on : ''}
          onClick={() => setTheme(id)}
          title={label}
          aria-label={`${label} theme`}
          aria-pressed={theme === id}
        >
          <Icon width={15} height={15} />
        </button>
      ))}
    </div>
  );
}
